import {
  DatabaseService,
  WebflowFormSubmissionEvent,
  WebflowFormSubmissionEventData,
} from "@/core";
import { EventRepository } from "@/core/ports/repositories/event-repository";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getEventRepository(
  databaseService: DatabaseService,
): EventRepository {
  return getGenericRepository<
    WebflowFormSubmissionEvent,
    WebflowFormSubmissionEventData
  >(() => DatabaseCollection.EVENTS, databaseService);
}
